import { IPaginationInput } from '@models/payload/customer';
import { CreateMenuItemPayload, UpdateMenuItemPayload, UpdateAvailabilityPayload } from '@models/payload/menuItem';
import { CreateCatalogMenuItemStockPayload, UpdateMenuItemStatusPayload } from '@models/payload/topping';
import { ropoloRequest } from '@services/axios';

const getMenuItem = async (params: IPaginationInput) => (await ropoloRequest.catalogMenuitemsList(params)).data;
const getAllMenuItem = async () => (await ropoloRequest.catalogMenucategoriesListList()).data;
const getAllMenuItemWithProducts = async () => (await ropoloRequest.catalogMenucategoriesAllList()).data;
const getMenuItemById = async (id: string) => (await ropoloRequest.catalogMenuitemsDetail(id)).data;
const changeMenuItemToggle = async (params: UpdateAvailabilityPayload) =>
  (await ropoloRequest.snappfoodMenuitemsProductavailabilityUpdate(params)).data;
const createMenuItem = async (params: CreateMenuItemPayload) =>
  (await ropoloRequest.snappfoodMenuitemsCreate(params)).data;
const updateMenuItem = async (params: UpdateMenuItemPayload) =>
  (await ropoloRequest.snappfoodMenuitemsUpdate(params)).data;
const removeMenuItem = async (id: string) => (await ropoloRequest.snappfoodMenuitemsDelete(id)).data;

const snappFoodMenuItemStatus = async (id: string) => (await ropoloRequest.snappfoodMenuitemsSnappinfoDetail(id)).data;

const snappFoodModifyStatus = async (command: UpdateMenuItemStatusPayload) =>
  (await ropoloRequest.snappfoodMenuitemsProductstatusUpdate(command)).data;

const catalogMenuitemtagList = async () => (await ropoloRequest.catalogMenuitemtagList()).data;

const syncCatalogMenuItems = async () => (await ropoloRequest.catalogMenuitemsSyncList()).data;

const searchMenuItem = async (search: string) => (await ropoloRequest.catalogMenuitemsBranchList({ search })).data;

const createCatalogMenuItemStock = async (command: CreateCatalogMenuItemStockPayload) =>
  (await ropoloRequest.catalogStocksCreate(command)).data;

const menuItemService = {
  getMenuItem,
  changeMenuItemToggle,
  createMenuItem,
  getAllMenuItem,
  getMenuItemById,
  updateMenuItem,
  snappFoodMenuItemStatus,
  snappFoodModifyStatus,
  removeMenuItem,
  getAllMenuItemWithProducts,
  catalogMenuitemtagList,
  syncCatalogMenuItems,
  searchMenuItem,
  createCatalogMenuItemStock,
};

export default menuItemService;
